"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separator = exports.Display = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Display = exports.Display = _styledComponents["default"].div.withConfig({
  displayName: "Displaystyle__Display",
  componentId: "sc-1266xyt-0"
})(function (_ref) {
  var alignItems = _ref.alignItems,
    type = _ref.type,
    justify = _ref.justify,
    spacing = _ref.theme.spacing;
  return {
    display: type,
    flexWrap: type === 'flex' && 'wrap',
    alignItems: alignItems,
    justifyContent: justify,
    marginLeft: "-".concat(spacing.inline['5xs']),
    marginRight: "-".concat(spacing.inline['5xs']),
    '> *': {
      margin: "".concat(spacing.inline['4xs'], " ").concat(spacing.inline['5xs'])
    }
  };
});
var Separator = exports.Separator = _styledComponents["default"].span.withConfig({
  displayName: "Displaystyle__Separator",
  componentId: "sc-1266xyt-1"
})({
  flexGrow: 1
});